import { getCountries, getCountryCallingCode } from 'react-phone-number-input';

const countryFlags: { [key: string]: string } = {
  US: '🇺🇸',
  CA: '🇨🇦',
  MX: '🇲🇽',
};

const allCountries = getCountries()
  .filter((country: string) => countryFlags[country])
  .map((country: string) => ({
    code: country,
    dialCode: `+${getCountryCallingCode(country as any)}`,
    name: country,
    flag: countryFlags[country],
  }));

export const countries = [
  ...allCountries.filter((c) => c.code === 'US'),
  ...allCountries.filter((c) => c.code === 'CA'),
  ...allCountries.filter((c) => c.code !== 'US' && c.code !== 'CA'),
];
